import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean'],
];

function RichTextEditor({ value, onChange, placeholder }) {
  const containerRef = useRef(null);
  const quillRef     = useRef(null);
  const onChangeRef  = useRef(onChange);
  const valueRef     = useRef(value);

  useEffect(() => { onChangeRef.current = onChange; }, [onChange]);
  useEffect(() => { valueRef.current = value; },       [value]);

  useEffect(() => {
    if (quillRef.current) return;

    const quill = new Quill(containerRef.current, {
      theme: 'snow',
      placeholder: placeholder || 'Escribe una descripción...',
      modules: { toolbar: TOOLBAR },
    });

    quillRef.current = quill;

    // Carga el valor inicial (clave para el modo edición)
    if (valueRef.current) {
      quill.root.innerHTML = valueRef.current;
    }

    quill.on('text-change', () => {
      const html = quill.root.innerHTML;
      onChangeRef.current(html === '<p><br></p>' ? '' : html);
    });
  }, [placeholder]);

  // Sincroniza si el value cambia externamente después del montaje
  const lastValueRef = useRef(value);
  useEffect(() => {
    const quill = quillRef.current;
    if (!quill) return;
    if (value !== lastValueRef.current) {
      lastValueRef.current = value;
      const sel = quill.getSelection();
      quill.root.innerHTML = value || '';
      if (sel) quill.setSelection(sel);
    }
  }, [value]);

  return <div ref={containerRef} style={{ background: '#fff', borderRadius: 4 }} />;
}

export default RichTextEditor;
